import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=ddda5314"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddda5314')) {
      api.createRecord('ddda5314', component.options)
    } else {
      api.reload('ddda5314', component.options)
    }
    module.hot.accept("./ChatIcon.vue?vue&type=template&id=ddda5314", function () {
      api.rerender('ddda5314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ChatIcon.vue"
export default component.exports